const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  fontName: "",
  fontPath: "",
};

const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    setFontName: (state, { payload: { fontName } }) => {
      state.fontName = fontName || "";
    },
    setFontPath: (state, { payload: { fontPath } }) => {
      state.fontPath = fontPath || "";
    },
  },
});

export const { setFontName, setFontPath } = companySlice.actions;
export default companySlice.reducer; 